/* eslint-disable no-underscore-dangle */
import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import { SortOrder } from '@gql/graphql';
import { useCallback, useState } from 'react';

export const ANNOUNCEMENTS_GET_ANNOUNCEMENTS = graphql(`
  query AnnouncementsGetAnnouncements(
    $orderBy: [AnnouncementOrderByWithRelationAndSearchRelevanceInput!]
    $translationWhere: AnnouncementTranslationWhereInput
    $take: Int
    $skip: Int
    $where: AnnouncementWhereInput
  ) {
    findManyAnnouncement(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      published
      countries
      translations(where: $translationWhere) {
        id
        title
        content
        language
      }
      createdAt
    }
    aggregateAnnouncement(where: $where) {
      _count {
        _all
      }
    }
  }
`);

export const useGetAnnouncements = (skip: boolean) => {
  const { language, countryCode } = useRouter();
  const [announcementsFetchMoreLoading, setAnnouncementsFetchMoreLoading] = useState(false);
  const { data, error, loading, fetchMore } = useQuery(ANNOUNCEMENTS_GET_ANNOUNCEMENTS, {
    variables: {
      where: { published: { equals: true }, countries: { has: countryCode } },
      take: 3,
      skip: 0,
      orderBy: [{ createdAt: SortOrder.desc }],
      translationWhere: { language: { equals: language }, content: { not: null } },
    },
    skip,
  });

  const announcementsFetchMore = useCallback(
    async (...args: Parameters<typeof fetchMore>) => {
      setAnnouncementsFetchMoreLoading(true);
      try {
        await fetchMore(...args);
      } finally {
        setAnnouncementsFetchMoreLoading(false);
      }
    },
    [fetchMore],
  );

  return {
    announcements: data?.findManyAnnouncement,
    announcementsCount: data?.aggregateAnnouncement?._count?._all ?? 0,
    announcementsError: error,
    announcementsLoading: loading,
    announcementsFetchMore,
    announcementsFetchMoreLoading,
  };
};
